<template>
  <fieldset>
      <div class="flex align-center inline-checkbox-outer">
          <input-checkbox
              label="Add a special request/comment"
              v-on:change="toggle">
          </input-checkbox>
      </div>
      <div v-if="show">
          <textarea
            v-on:input="onInput"
            v-model="specialRequest"
            placeholder="Special request/comment">
          </textarea>
      </div>
  </fieldset>
</template>

<script>
  import inputWithValidation from './inputWithValidation'
  import inputCheckbox from './inputCheckbox'

  export default {
    name: 'specialRequest',
    components: {
      inputWithValidation,
      inputCheckbox
    },
    props: [
      'value'
    ],
    data () {
      return {
        show: false,
        specialRequest: this.value
      }
    },
    methods: {
      toggle () {
        this.show = !this.show
      },
      onInput () {
        this.$emit('input', this.specialRequest)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// specialRequest.vue?b0c38748